import Swiper, {Navigation, Pagination, Controller} from 'swiper';

const ambassadors = document.getElementById('ambassador_container')
let ambassadorsSliderOptions = {
    slidesPerView: 3,
    centeredSlides: true,
    roundLengths: true,
    loop: true,
    slidesPerView_1200: 5
}
if (ambassadors) {
    const ambassadorsCount = ambassadors.dataset.ambassadorsCount

    switch (ambassadorsCount) {
        case '1':
            ambassadorsSliderOptions = {
                slidesPerView: 1,
                centeredSlides: false,
                loop: false,
                slidesPerView_1200: 1,
                initialSlide: 0,
            }
            break;
        case '2':
            ambassadorsSliderOptions = {
                slidesPerView: 1,
                centeredSlides: false,
                loop: true,
                slidesPerView_1200: 1,
                initialSlide: 0,
            }
            break;
        case '3':
            ambassadorsSliderOptions = {
                slidesPerView: 3,
                centeredSlides: true,
                loop: true,
                slidesPerView_1200: 3,
                initialSlide: 1,
            }
            break;
        case '4':
            ambassadorsSliderOptions = {
                slidesPerView: 3,
                centeredSlides: true,
                loop: true,
                slidesPerView_1200: 3,
                initialSlide: 0,
            }
            break;
        default:
            ambassadorsSliderOptions = {
                slidesPerView: 3,
                centeredSlides: true,
                loop: true,
                slidesPerView_1200: 5,
                initialSlide: 0,
            }
    }
}


Swiper.use([Navigation, Pagination, Controller]);

// AMBASSADOR SLIDER USING SWIPERJS
(function () {
    // var ambassadorSliderTitle = new Swiper(".ambassador-slider-title", {
    //     loop: true,
    //     loopAdditionalSlides: 30,
    // });

    var ambassadorSliderCard = new Swiper(".ambassador-slider-card", {
        roundLengths: true,
        slideToClickedSlide: true,
        slidesPerView: ambassadorsSliderOptions.slidesPerView,
        centeredSlides: ambassadorsSliderOptions.centeredSlides,
        loop: ambassadorsSliderOptions.loop,
        initialSlide: ambassadorsSliderOptions.initialSlide,

        pagination: {
            el: ".swiper-pagination",
            dynamicBullets: true,
            clickable: true
        },
        navigation: {
            nextEl: ".dm-swiper-button-next",
            prevEl: ".dm-swiper-button-prev",
        },
        breakpoints: {
            // when window width is >= 320px
            // 768: {
            //     slidesPerView: 2,
            //     spaceBetween: 20
            // },
            // when window width is >= 480px
            // 992: {
            //     slidesPerView: 5,
            // },
            // when window width is >= 640px
            1200: {
                slidesPerView: ambassadorsSliderOptions.slidesPerView_1200,

            }
        }
    });
//

    // ambassadorSliderTitle.controller.control = ambassadorSliderCard;
    // ambassadorSliderCard.controller.control = ambassadorSliderTitle;
})();